import request from './public'

export const registerForWeb = (params) => {
  return request.post('/single/home/registerForWeb', params)
}
export const getSmsCode = (params) => {
  return request.post('/single/home/sendSmsCodeForWeb', params)
}
export const loginForWeb = (params) => {
  return request.post('/single/home/loginForWeb', params)
}
export const loginByCodeForWeb = (params) => {
  return request.post('/single/home/loginByCodeForWeb', params)
}
export const userInfoForWeb = (params) => {
  return request.post('/single/home/userInfoForWeb', params)
}
export const submitUserInfoForWeb = (params) => {
  return request.post('/single/home/submitUserInfoForWeb', params)
}
export const submitGgxx = (params) => {
  return request.post('/single/home/submitGgxx', params)
}
export const searchGgxxPage = (params) => {
  return request.post('/single/home/searchGgxxPage', params)
}
export const searchGgxxRealCountBatch = (params) => {
  return request.post('/single/home/searchGgxxRealCountBatch', params)
}
export const ggxxDetail = (params) => {
  return request.post('/single/home/ggxxDetail', params)
}
export const searchMyGgxxList = (params) => {
  return request.post('/single/home/searchMyGgxxList', params)
}
export const searchMyGgxxPage = (params) => {
  return request.post('/single/home/searchMyGgxxPage', params)
}

export const countMyGgxxNumber = (params) => {
  return request.post('/single/home/countMyGgxxNumber', params)
}
export const visitorList = (params) => {
  return request.post('/single/home/visitorList', params)
}

export const visitorAllList = (params) => {
  return request.post('/single/home/visitorAllList', params)
}
export const quantityStatistics = (params) => {
  return request.post('/single/home/quantityStatistics', params)
}
export const payGgxx = (params) => {
  return request.post('/single/home/payGgxx', params)
}
export const searchBannerList = (params) => {
  return request.post('/single/home/searchBannerList', params)
}
///////////////////////////////////////////////////////////////
// 登陆
export const userLogin = (params) => {
  return request.post('/single/home/login', params)
}
// 退出登陆
export const loginOut = (params) => {
  return request.get('/single/home/logout', params)
}
// 用户信息
export const userInfo = (params) => {
  return request.get('/single/user/currentMember', params)
}
// 注册账号
export const register = (params) => {
  return request.post('/single/home/simpleReg', params)
}

// 获取优惠券
export const acceptCoupon = (params) => {
  return request.post('/single/sms/add', params)
}
// 优惠券列表
export const listMemberCoupon = (params) => {
  return request.get('/single/sms/listMemberCoupon', params)
}
//  优惠券
export const couponList = (params) => {
  return request.get('/single/home/couponList', params)
}
//  可领取的优惠券
export const selectNotRecive = (params) => {
  return request.get('/single/home/selectNotRecive', params)
}


// 上传图片
export const upload = (params) => {
  return request.get('/single/home/upload', params)
}
// 修改头像
export const updateheadimage = (params) => {
  return request.get('/user.editinfo', params)
}
// 捐赠列表
export const thanksList = (params) => {
  return request.get('/member/thanks', params)
}
// 首页接口
export const productHome = (params) => {
  return request.get('/pc.getpageconfig', params)
}
// 首页接口
export const bannerList = (params) => {
  return request.get('/single/home/bannerList', params)
}
export const navList = (params) => {
  return request.get('/single/home/navlist', params)
}
// 查询热销商品
export const hotProductList = (params) => {
  return request.get('/single/sms/homeRecommendProduct/list', params)
}
// 查询首页推荐品牌
export const recommendBrand = (params) => {
  return request.get('/single/sms/homeBrand/list', params)
}
// 查询首页新品
export const newProductList = (params) => {
  return request.get('/single/sms/homeNewProduct/list', params)
}
//  商户列表
export const storeList = (params) => {
  return request.get('/single/store/store/list', params)
}

//  商户入驻
export const applyStore = (params) => {
  return request.get('/single/store/applyStore', params)
}
//  商户详情 带用户
export const storeDetail = (params) => {
  return request.get('/single/store/detail', params)
}
//  商户主页
export const storeDetail1 = (params) => {
  return request.get('/single/store/detail1', params)
}
//  商户列表
export const storeHome = (params) => {
  return request.get('/single/store/home', params)
}
// 捐赠板块
export const thank = (params) => {
  return request.get('/goods/thank', params)
}
// 查询商品分类列表(带商品)
export const categoryAndGoodsList = (params) => {
  return request.get('/single/pms/categoryAndGoodsList/list', params)
}

export const brandList = (params) => {
  return request.get('/single/pms/brand/list', params)
}
export const goodsList = (params) => {
  return request.get('/single/pms/goods/list', params)
}


// 极验验证码
export const geetest = (params) => {
  return request.get('/member/geetestInit?t=' + (new Date()).getTime(), params)
}




// WEBPACK FOOTER //
// ./src/api/index.js